import { ActionCreator } from "redux";
import { UpdateContentTitleAction } from "./types";

export const updateContentTitle: ActionCreator<UpdateContentTitleAction> = (title: string) => ({
  type: "@@content-title/UPDATE_CONTENT_TITLE",
  payload: title
});
